import DeliveryTypeEnum from "../enums/DeliveryTypeEnum";
import { PricePolicyEnum } from "../enums/PricePolicyEnum";
import { RateTypeShippingEnum } from "../enums/RateTypeShippingEnum";

export const conciliationProperty = (type, conciliation) => {
    const policy = conciliation?.shipping?.correios?.politicaDePreco;
    const isPricePolicyFixed = policy?.type === PricePolicyEnum.TYPE.FIXED;

    let conciliationProp;
    let conciliationPropDiff;
    let oldProp;
    switch (type) {
        case "height":
            conciliationProp = Number(conciliation?.shipping?.height);
            conciliationPropDiff = Number(conciliation?.heightDiff);
            oldProp = conciliationPropDiff + conciliationProp;
            break;

        case "weight":
            conciliationProp = Number(conciliation?.shipping?.weight);
            conciliationPropDiff = Number(conciliation?.weightDiff);
            oldProp = (conciliationPropDiff + conciliationProp).toFixed(2);
            break;

        case "billedWeight":
            // peso declarado
            const weight = Number(conciliation?.shipping?.weight);
            const length = Number(conciliation?.shipping?.length);
            const height = Number(conciliation?.shipping?.height);
            const width = Number(conciliation?.shipping?.width);
            const cubWeight = (length * height * width) / 6000;

            const oldWeight =
                Number(conciliation?.shipping?.weight) +
                Number(conciliation?.weightDiff);
            const oldWidth =
                Number(conciliation?.shipping?.width) +
                Number(conciliation?.widthDiff);
            const oldHeight =
                Number(conciliation?.shipping?.height) +
                Number(conciliation?.heightDiff);
            const oldLength =
                Number(conciliation?.shipping?.length) +
                Number(conciliation?.lengthDiff);
            const oldCubWeight = (oldLength * oldHeight * oldWidth) / 6000;
            const oldConciliationProp =
                oldCubWeight > 5 && oldWeight < oldCubWeight
                    ? oldCubWeight.toFixed(2)
                    : oldWeight.toFixed(2);

            conciliationPropDiff =
                cubWeight > 5 && weight < cubWeight ? cubWeight : 0;

            conciliationProp =
                cubWeight > 5 && weight < cubWeight
                    ? cubWeight.toFixed(2)
                    : weight.toFixed(2);

            oldProp = oldConciliationProp;
            break;

        case "width":
            conciliationProp = Number(conciliation?.shipping?.width);
            conciliationPropDiff = Number(conciliation?.widthDiff);
            oldProp = conciliationPropDiff + conciliationProp;
            break;

        case "length":
            conciliationProp = Number(conciliation?.shipping?.length);
            conciliationPropDiff = Number(conciliation?.lengthDiff);
            oldProp = conciliationPropDiff + conciliationProp;
            break;

        case "price":
            conciliationProp = Number(conciliation?.shipping?.price);
            conciliationPropDiff = isPricePolicyFixed ? 0 : Number(conciliation?.priceDiff);
            oldProp = isPricePolicyFixed ? conciliationProp : conciliationPropDiff + conciliationProp;
            break;

        case "discount":
            const valorComDescontoOriginal = conciliation?.shipping?.correios?.valorComDescontoOriginal;
            const valorComDesconto = conciliation?.shipping?.correios?.valorComDesconto;
            const discountValue = policy ? (valorComDescontoOriginal - valorComDesconto) : 0;
            const priceDiff = Number(conciliation?.priceDiff);

            conciliationProp = policy?.percentage ? discountValue : 0;

            if (isPricePolicyFixed) {
                const oldPrice = priceDiff + valorComDescontoOriginal;
                oldProp = oldPrice - valorComDesconto;
                conciliationPropDiff = priceDiff !== 0 ? 1 : 0
                break;
            }

            const actualPrice = Number(conciliation?.shipping?.price);
            const oldPrice = priceDiff + actualPrice;
            const typePolice = policy?.type === PricePolicyEnum.TYPE.INCREASE ? (1 + policy?.percentage / 100) : (1 - policy?.percentage / 100);
            const oldDiscountPrice = Number(Number(oldPrice / typePolice).toFixed(2));

            oldProp = policy?.percentage ? (oldDiscountPrice - oldPrice) : 0;
            conciliationPropDiff = policy?.percentage && (conciliationProp !== oldProp) ? (!!oldProp ? 1 : 0) : 0;
            break;

        case "type":
            conciliationProp = conciliation?.shipping?.correios?.type === DeliveryTypeEnum.OWN_DELIVERY ? "Super Expressa" : conciliation?.shipping?.correios?.type;
            conciliationPropDiff = conciliation?.typeDiff === DeliveryTypeEnum.OWN_DELIVERY ? "Super Expressa" : conciliation?.typeDiff;
            break;

        case "originCity":
            conciliationProp = `${conciliation?.shipping?.origin?.city}/${conciliation?.shipping?.origin?.state}`;
            conciliationPropDiff = conciliation?.originCityDiff;
            break;

        case "rateType":
            conciliationProp =
                conciliation?.shipping?.rateType === RateTypeShippingEnum.COLLECT
                    ? "Sim"
                    : "Não";
            conciliationPropDiff =
                conciliation?.rateTypeDiff !== "" &&
                    conciliation?.rateTypeDiff === RateTypeShippingEnum.COLLECT
                    ? "Sim"
                    : "Não";
            break;

        default:
            conciliationProp = conciliation?.shipping?.format;
            conciliationPropDiff = conciliation?.formatDiff;
            break;
    }

    return {
        conciliationProp,
        conciliationPropDiff,
        oldProp
    }
};